import React, { useEffect, useState } from "react";
import { useParams, withRouter } from "react-router-dom";
import * as jwt from "jsonwebtoken";
import { pathOr } from "ramda";
import loginService from "../../service/login";
import { checkUserExist, LoginSagaAction } from "../../sagas/saga-actions";
import { setPopup } from "../../actions/popupAction";
import { connect } from "react-redux";
import UserService from "../../service/UserService";
import socketService from "../../helper/socketService";
import LoadingSpinner from "../loadingSpinner";
import CustomNotification from "../notification";
import {
  PRACTICE_EDITION_WHITELABEL,
  TOKEN_NAMES,
} from "../../constants/constants";

const userService = new UserService();
const SingleSignOn = (props) => {
  const { customPopupMessage, messageType, message } = props.popupReducer;

  const [loading, setLoading] = useState(true);
  const { token } = useParams();
  const urlSearchString = window.location.search;

  const params = new URLSearchParams(urlSearchString);
  const userId = params.get("userId");
  const url = params.get("url");

  const decodedTokens = jwt.decode(token, { complete: true });
  localStorage.setItem(TOKEN_NAMES.SSO, token);

  const autoLogin = async () => {
    try {
      await userService.verifySSO(token);
      const redirected = false;

      const { payload: userDetails } = decodedTokens;

      const mainOrSub = userDetails?.mainOrSub;
      const role = userDetails?.roles?.roleKey;

      if (["OU", "TS", "HA"].includes(role)) {
        props.history.push({
          pathname: "/admin-login",
          state: {
            sso: true,
            role,
            userId,
            url,
          },
        });
        return;
      }

      if (
        userDetails.roles.roleKey === "CR" &&
        userDetails.roleType === "internal"
      ) {
        props.history.push({
          pathname: "/admin-login",
          state: {
            sso: true,
            role: userDetails?.roles?.roleKey,
            userId,
            url,
          },
        });

        return;
      }

      if (
        role === "CR" &&
        userDetails.roles.accountAssociated === 1 &&
        userDetails.roleType === "external"
      ) {
        props.history.push({
          pathname: "/admin-login",
          state: {
            sso: true,
            role,
            userId,
            url,
          },
        });
        return;
      }

      if (!userDetails.practiceId) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: `Invalid credentials!`,
        });
        redirected = true;
        return;
      }

      if (userDetails.isConfig && !userDetails.directLoginLC) {
        props.history.push({
          pathname: "/login-by-dept",
          state: {
            mainOrSub,
            role,
            roleType: userDetails?.roleType || "",
          },
        });
        return;
      }

      loginService.doLogin(decodedTokens.payload, "", "");
      props.LoginSagaAction(userDetails);
      props.checkUserExist(userDetails);
      setLoading(false);

      const {
        liveChatAccess,
        broadcastAccess,
        liveAgentAccess,
        reportOnlyAccess,
      } = userDetails;
      if (PRACTICE_EDITION_WHITELABEL) {
        const url = params.get("url");
        if (url) {
          props.history.push(url);
          return;
        }
      }
      if (liveChatAccess || reportOnlyAccess) props.history.push("/chat");
      else if (liveAgentAccess) props.history.push("/chat-agent");
      else if (broadcastAccess || reportOnlyAccess)
        props.history.push("/broadcast");
      else {
        redirected = true;
        loginService.Logout();
        props.setPopup({
          customPopupMessage: true,
          message: "You do not have access",
          messageType: "error",
        });
        props.history.push("/login");
      }
      if (!redirected) {
        socketService.init();
      }
    } catch (err) {
      setLoading(false);
      loginService.Logout();
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Internal Server Error. Please check the connection",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
      props.history.push("/login");
    }
  };
  useEffect(() => {
    autoLogin();
  }, []);

  return (
    <>
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      {loading && <LoadingSpinner customClassName="preview-loader" />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    checkUserExist: (data) => dispatch(checkUserExist(data)),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SingleSignOn)
);
